import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Muestra una tanda de recovery codes de MFA UNA ÚNICA VEZ (justo después de
 * activar MFA o de regenerarlos). El backend nunca los vuelve a exponer en
 * texto plano, así que este componente es la única oportunidad del usuario
 * de guardarlos - de ahí los botones de copiar/descargar y el aviso.
 *
 * No persiste los códigos en ningún sitio (localStorage, etc.) - viven solo
 * en las props mientras el padre los mantenga montados.
 *
 * @param {string[]} codes - Recovery codes en texto plano.
 * @param {string} generatedAt - ISO datetime en que se generaron (informativo).
 * @param {function} onDone - Callback al confirmar que se han guardado.
 */
const RecoveryCodesDisplay = ({ codes, generatedAt, onDone }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const codeList = Array.isArray(codes) ? codes : [];

  const handleCopy = async () => {
    const text = codeList.join('\n');
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      // Si falla el copiado, los códigos siguen visibles en pantalla para copiarlos a mano.
    }
  };

  const handleDownload = () => {
    const text = codeList.join('\n');
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'idax-recovery-codes.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="mfa-recovery-codes">
      <p>{t('profile.mfa.wizard.codes.body')}</p>

      <ul className="mfa-recovery-codes-list">
        {codeList.map((codeValue) => (
          <li key={codeValue}>{codeValue}</li>
        ))}
      </ul>

      <div className="mfa-recovery-codes-actions">
        <button type="button" className="btn btn-secondary" onClick={handleCopy}>
          <i className="fa fa-copy"></i> {copied ? t('profile.mfa.wizard.codes.copied') : t('profile.mfa.wizard.codes.copy')}
        </button>
        <button type="button" className="btn btn-secondary" onClick={handleDownload}>
          <i className="fa fa-download"></i> {t('profile.mfa.wizard.codes.download')}
        </button>
      </div>

      <p className="mfa-recovery-codes-warning">
        <i className="fa fa-exclamation-triangle"></i> {t('profile.mfa.wizard.codes.warning')}
      </p>

      <button type="button" className="btn btn-primary mfa-recovery-codes-done" onClick={onDone}>
        {t('profile.mfa.wizard.codes.done')}
      </button>
    </div>
  );
};

export default RecoveryCodesDisplay;
